import { useCallback } from "react"
import { useNavigate } from "react-router-dom"
import { useConfirmDialog } from "./useConfirmDialog"
import {
    genCleaningInfoPagePath,
    genOperationInfoPagePath
} from "@/routes/protected"

type DetailType = "cleaning" | "operation"

export const useNavigateBackToDetail = (type: DetailType, id: string) => {
    const navigate = useNavigate()
    const { open, openDialog, closeDialog } = useConfirmDialog()

    const goBack = useCallback(() => {
        closeDialog()
        const path =
            type === "cleaning"
                ? genCleaningInfoPagePath(id, "info")
                : genOperationInfoPagePath(id, "info")
        navigate(path)
    }, [type, id, navigate, closeDialog])

    return {
        confirmBackOpen: open,
        openConfirmBack: openDialog,
        closeConfirmBack: closeDialog,
        goBackToDetail: goBack
    }
}
